import React from "react";
import {
  Box, Divider, FormControl, FormControlLabel,
  FormLabel, Grid, Radio, RadioGroup, TextField, Typography,
} from "@mui/material";

export default function RgsConfig({ form, onChange }) {
  return (
    <Box>
      <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
        Cuenta RGS+
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Configura el acceso del paciente a la aplicación RGS+.
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={2.5}>

        {/* Credenciales */}
        <Grid item xs={12}>
          <Typography variant="subtitle2" fontWeight={700} color="text.secondary"
            sx={{ textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>
            Credenciales de acceso
          </Typography>
          <Divider />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Nombre de usuario"
            name="PATIENT_USER"
            value={form.PATIENT_USER}
            onChange={onChange}
            fullWidth
            autoComplete="off"
            helperText="Identificador único en la app RGS+"
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Contraseña inicial"
            name="PASSWORD"
            type="password"
            value={form.PASSWORD}
            onChange={onChange}
            fullWidth
            autoComplete="new-password"
            helperText="El paciente podrá cambiarla desde la app"
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Email"
            name="EMAIL"
            type="email"
            value={form.EMAIL}
            onChange={onChange}
            fullWidth
          />
        </Grid>

        {/* Configuración clínica RGS+ */}
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography variant="subtitle2" fontWeight={700} color="text.secondary"
            sx={{ textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>
            Configuración clínica
          </Typography>
          <Divider />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControl>
            <FormLabel>Extremidad a entrenar</FormLabel>
            <RadioGroup
              row
              name="UPPER_EXTREMITY_TO_TRAIN"
              value={form.UPPER_EXTREMITY_TO_TRAIN}
              onChange={onChange}
            >
              <FormControlLabel value="LEFT"  control={<Radio />} label="Izquierda" />
              <FormControlLabel value="RIGHT" control={<Radio />} label="Derecha" />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControl>
            <FormLabel>Capacidad de elevación de mano</FormLabel>
            <RadioGroup
              name="HAND_RAISING_CAPACITY"
              value={form.HAND_RAISING_CAPACITY}
              onChange={onChange}
            >
              <FormControlLabel value="NONE"   control={<Radio />} label="Sin capacidad" />
              <FormControlLabel value="LOW"    control={<Radio />} label="Baja" />
              <FormControlLabel value="MEDIUM" control={<Radio />} label="Media" />
              <FormControlLabel value="HIGH"   control={<Radio />} label="Alta" />
            </RadioGroup>
          </FormControl>
        </Grid>

      </Grid>
    </Box>
  );
}
